import { render, staticRenderFns } from "./ChoosePanel.vue?vue&type=template&id=13fcbfb2&scoped=true&"
import script from "./ChoosePanel.vue?vue&type=script&lang=js&"
export * from "./ChoosePanel.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePanel.vue?vue&type=style&index=0&id=13fcbfb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fcbfb2",
  null
  
)

export default component.exports